import React from 'react';
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';
import logo from "../assets/University Officials/image3.jpg"; // Update the path/image if needed

const DeanofColleges = () => {
    return (
        <div className="container mt-5 mb-5">
            <Card className="shadow border-0 rounded-4">
                <div className="row g-0">
                    <div className="col-md-4 d-flex align-items-center justify-content-center p-4">
                        <img
                            src={logo}
                            alt="महाविद्यालय अधिष्ठाता"
                            className="img-fluid rounded-3 shadow-sm"
                            style={{ maxHeight: '300px', objectFit: 'cover' }}
                        />
                    </div>
                    <div className="col-md-8">
                        <CardBody className="p-4">
                            <CardTitle tag="h4" className="text-center text-primary fw-bold">
                                महाविद्यालय अधिष्ठाता
                            </CardTitle>
                            <CardText className="fs-5">
                                <strong>प्रो. संजय गोयल</strong><br />
                                महाविद्यालय अधिष्ठाता
                            </CardText>
                            <hr />
                            <CardText className="mt-3">
                                <strong>संपर्क:</strong> 01746-297260<br />
                                <strong>ई-मेल:</strong> <a href="mailto:doc@mvsu.ac.in">doc@mvsu.ac.in</a><br />
                                <strong>अस्थाई परिसर:</strong><br />
                                डॉ. भीम राव अम्बेड़कर राजकीय महाविद्यालय,<br />
                                जगदीशपुरा, कैथल (हरियाणा) - 136027
                            </CardText>
                        </CardBody>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default DeanofColleges;
